import api from "./api";

/** GET /business/profile/2fa/status */
export const fetchTwoFactorStatus = async () => {
  const { data } = await api.get("/business/profile/2fa/status");
  return data.data;
};

/**
 * POST /business/profile/2fa/enable — starts the setup. Returns the QR code as
 * an inline SVG string plus the secret for manual entry. 2FA is not active
 * until confirmTwoFactor() succeeds.
 */
export const enableTwoFactor = async (password) => {
  const { data } = await api.post("/business/profile/2fa/enable", { password });
  return data.data;
};

/** POST /business/profile/2fa/confirm — returns the recovery codes, once. */
export const confirmTwoFactor = async (code) => {
  const { data } = await api.post("/business/profile/2fa/confirm", { code });
  return data.data;
};

/** POST /business/profile/2fa/recovery-codes — a new batch, also shown once. */
export const regenerateRecoveryCodes = async (password) => {
  const { data } = await api.post("/business/profile/2fa/recovery-codes", { password });
  return data.data.recovery_codes;
};

/** DELETE /business/profile/2fa — the password rides in the body, not the URL. */
export const disableTwoFactor = (password) => api.delete("/business/profile/2fa", { data: { password } });
